"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = reducer;

var _rootActions = require("./rootActions");

function reducer(state, action) {
  switch (action.type) {
    case 'CLICK_NUMB':
      return (0, _rootActions.clickNumb)(state, action);

    case 'SET_SLIDE':
      return (0, _rootActions.setSlide)(state, action);

    case 'SET_DATA':
      return (0, _rootActions.setData)(state, action);

    default:
      return state;
  }
}